export const getBlueChartColorsSet = (itemsCount: number) =>
  itemsCount > 4
    ? [
        '#0369A1',
        '#0278B5',
        '#0389C7',
        '#01A0D8',
        '#25B0E5',
        '#4BC1F1',
        '#77D1F9',
        '#77D1F9',
        '#77D1F9',
        '#A6E1FD',
        '#D4D4D4',
        '#0369A1',
        '#0278B5',
        '#0389C7',
        '#01A0D8',
        '#25B0E5',
        '#4BC1F1',
        '#77D1F9',
        '#77D1F9',
        '#77D1F9',
        '#A6E1FD',
        '#D4D4D4',
        '#0369A1',
        '#0278B5',
        '#0389C7',
        '#01A0D8',
        '#25B0E5',
        '#4BC1F1',
        '#77D1F9',
        '#77D1F9',
        '#77D1F9',
        '#A6E1FD',
        '#D4D4D4',
        '#0369A1',
        '#0278B5',
        '#0389C7',
        '#01A0D8',
        '#25B0E5',
        '#4BC1F1',
        '#77D1F9',
        '#77D1F9',
        '#77D1F9',
        '#A6E1FD',
        '#D4D4D4',
      ]
    : ['#0369A1', '#01A0D8', '#4BC1F1', '#A6E1FD'];
